import { useEffect, useState } from 'react';
import { DEFAULT_MEDIA_ASPECT_RATIO } from './mediaFit';

/* Ratios déjà détectés, par URL. La virtualisation du canvas Puck démonte et
   remonte les blocs au défilement et mesure leur hauteur au montage : repartir
   du repli à chaque remontage faisait changer la hauteur juste après la mesure,
   et le bloc entrait et sortait de la plage en boucle (cf. puckeditor/puck#1634). */
const detectedRatios = new Map();

/** Ratio largeur / hauteur détecté depuis le fichier image (ou repli). */
export function useImageAspectRatio(src, fallback = DEFAULT_MEDIA_ASPECT_RATIO) {
  const [ratio, setRatio] = useState(() => detectedRatios.get(src) ?? fallback);

  useEffect(() => {
    if (!src || typeof src !== 'string') {
      setRatio(fallback);
      return undefined;
    }

    const known = detectedRatios.get(src);
    if (known) {
      setRatio(known);
      return undefined;
    }

    let cancelled = false;
    const img = new Image();

    img.onload = () => {
      if (img.naturalWidth > 0 && img.naturalHeight > 0) {
        const detected = img.naturalWidth / img.naturalHeight;
        detectedRatios.set(src, detected);
        if (!cancelled) setRatio(detected);
      }
    };

    img.onerror = () => {
      if (!cancelled) setRatio(fallback);
    };

    img.src = src;

    return () => {
      cancelled = true;
    };
  }, [src, fallback]);

  return ratio;
}
